export default {
  getList: {
    method: 'post',
    url: '/admincp/workspaces/list'
  },
  create: {
    method: 'post',
    url: '/admincp/workspaces'
  }
}
